<template>
  <v-container class="pr-0 pl-0" fluid>
    <!-- Row to organize insights in cards -->
    <v-row>
      
      <!-- Insight 1: User with Most Treinos (Overall) -->
      <v-col cols="12" md="6" lg="4" xl="3" v-if="userWithMostTreinos" :disabled="dialogLoader">
        <v-card class="elevation-10" dense>
          <v-card-title>
            <v-icon left>mdi-trophy-award</v-icon>{{ userWithMostTreinos.fullName }}
          </v-card-title>
          <v-card-text class="body-1">
            É líder em treinos. São {{ userWithMostTreinos.treinoCount }} treinos na plataforma para o líder em número de treinos.
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>

      <!-- Insight 2: User with Most Treinos (Corrida) -->
      <v-col cols="12" md="6" lg="4" xl="3" v-if="userWithMostTreinosCorrida" :disabled="dialogLoader">
        <v-card class="elevation-10" dense>
          <v-card-title>
            <v-icon left>mdi-run-fast</v-icon>{{ userWithMostTreinosCorrida.fullName }}
          </v-card-title>
          <v-card-text class="body-1">
            É líder na corrida. São {{ userWithMostTreinosCorrida.treinoCount }} treinos de Corrida.
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>

      <!-- Insight 3: User with Most Treinos (Ciclismo) -->
      <v-col cols="12" md="6" lg="4" xl="3" v-if="userWithMostTreinosCiclismo" :disabled="dialogLoader">
        <v-card class="elevation-10" dense>
          <v-card-title>
            <v-icon left>mdi-bike-fast</v-icon>{{ userWithMostTreinosCiclismo.fullName }}
          </v-card-title>
          <v-card-text class="body-1">
            É líder em ciclismo. São {{ userWithMostTreinosCiclismo.treinoCount }} treinos de Ciclismo.
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>

      <!-- Insight 4: User with Most Treinos (Natação) -->
      <v-col cols="12" md="6" lg="4" xl="3" v-if="userWithMostTreinosNatacao" :disabled="dialogLoader">
        <v-card class="elevation-10" dense>
          <v-card-title>
            <v-icon left>mdi-swim</v-icon>{{ userWithMostTreinosNatacao.fullName }}
          </v-card-title>
          <v-card-text class="body-1">
            É líder na natação. São {{ userWithMostTreinosNatacao.treinoCount }} treinos de Natação.
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Loader for insights -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Loading insights...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import HOST from '@/ws'

export default {
  data() {
    return {
      dialogLoader: false,
      userWithMostTreinos: null,
      userWithMostTreinosCorrida: null,
      userWithMostTreinosCiclismo: null,
      userWithMostTreinosNatacao: null,
    };
  },

  beforeMount(){
    this.loadAllInsights();
  },

  methods: {

    // Method that loads all insights
    async loadAllInsights() {
      try {
        this.dialogLoader = true;

        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
        };

        // Fetch insight for user with most treinos (Overall)
        let response = await this.axios.get(HOST.HOST + '/api/insights/user-with-most-treinos', config);
        this.userWithMostTreinos = response.data;

        // Fetch insight for user with most treinos (Corrida)
        response = await this.axios.get(HOST.HOST + '/api/insights/user-with-most-treinos-by-esporte?esporte=Corrida', config);
        this.userWithMostTreinosCorrida = response.data;

        // Fetch insight for user with most treinos (Ciclismo)
        response = await this.axios.get(HOST.HOST + '/api/insights/user-with-most-treinos-by-esporte?esporte=Ciclismo', config);
        this.userWithMostTreinosCiclismo = response.data;

        // Fetch insight for user with most treinos (Natação)
        response = await this.axios.get(HOST.HOST + '/api/insights/user-with-most-treinos-by-esporte?esporte=Natação', config);
        this.userWithMostTreinosNatacao = response.data;

      } catch (error) {
        console.error('Error loading insights data:', error);
        this.$store.commit("logout");
        this.$router.push("/");
      } finally {
        this.dialogLoader = false;
      }
    },
  },
};
</script>
